<template>
  <div class="mfooter">
    <img src="../../assets/image/logo-small.png" alt="" class="mfooter-logo">
    <ul class="mfooter-list">
      <li class="mfooter-list-item" v-for="(item, index) in footerList" :key="index">{{item}}</li>
    </ul>
    <p class="mfooter-desc">版权所有：中国科学院离退休干部工作局</p>
    <p class="mfooter-desc">技术支持：中国科学院文献情报中心</p>
    <p class="mfooter-desc">京ICP备05002861号|京公网安备</p>
    <div class="mfooter-code">
      <div class="mfooter-code-item">
        <img src="../../assets/image/applets-code.png" alt="" class="mfooter-code-item-image">
        <span class="mfooter-code-item-txt">关注小程序</span>
      </div>
      <div class="mfooter-code-item">
        <img src="../../assets/image/wechat-code.png" alt="" class="mfooter-code-item-image">
        <span class="mfooter-code-item-txt">关注公众号</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      footerList: ['关于我们', '关注我们', '联系我们', '合作机构', '版权声明']
    }
  }
}
</script>
<style lang="less" scoped>
.mfooter{
  display: flex;
  flex-direction: column;
  padding: 0 4vw;
  width:100%;
  height:77.87vw;
  background: #004D9A;
  box-sizing: border-box;
  overflow: hidden;
  &-logo{
    margin-bottom: 4.67vw;
    margin-top: 6.67vw;
    width: 45.33vw;
    height: 7.47vw;
  }
  &-list{
    display: flex;
    width: 100%;
    height:3.6vw;
    margin-bottom: 2.13vw;
    &-item{
      padding: 0 1.33vw;
      font-size:3.47vw;
      font-family:PingFang SC;
      font-weight:300;
      color:rgba(204,204,204,1);
      border-right: 0.13vw solid #CCCCCC;
      &:first-child{
        padding-left: 0;
      }
      &:last-child{
        border-right: none;
      }
    }
  }
  &-desc{
    height: 4vw;
    font-size:3.47vw;
    font-family:PingFang SC;
    font-weight:300;
    color:rgba(129,185,241,1);
    line-height:4vw;
  }
  &-code{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 6.67vw;
    &-item{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 11.07vw;
      &:last-child{
        margin-right: 0;
      }
      &-image{
        margin-bottom: 2.27vw;
        height: 23.2vw;
        width: 23.2vw;
      }
      &-txt{
        font-size:3.2vw;
        font-family:Microsoft YaHei;
        font-weight:400;
        color:rgba(129,185,241,1);
      }
    }
  }
}
</style>
